import { Box, Button, Heading, Text, Image, VStack } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';

import { getQuoteByCO2Api, Quote } from '../../api/quoteApi';
import { getActiveCountryByCode } from '../calculation/calculations';
import { WidgetContext } from '../context/Widget-context';

export type OffsetColumn = {
  title: string;
  description: string;
  image: { src: string; alt: string };
  removeRightMargin?: boolean;
  emissionQuantityKg: number;
  planURL: string;
};

export const OffsetColumn = (props: OffsetColumn) => {
  const { countryCode, regionKey } = useContext(WidgetContext);

  const [quote, setQuote] = useState<Quote | undefined>(undefined);
  const [quoteURL, setQuoteURL] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (quote) {
      const url = `${props.planURL}&quoteId=${encodeURIComponent(
        quote.quoteId,
      )}`;
      setQuoteURL(url);
    }
  }, [quote]);

  useEffect(() => {
    getQuoteByCO2Api(
      {
        merchantCode: 'CARBONCLICK',
        currency: getActiveCountryByCode(countryCode).currency,
        co2Quantity: props.emissionQuantityKg / 12,
        activityType: 'BUSINESS_FOOTPRINT',
        paymentProvider: 'STRIPE',
        basketCountry: countryCode
      },
      getActiveCountryByCode(countryCode).locale,
    )
      .then((response: any) => response.data)
      .then((data: any) => setQuote(data))
      .catch((reason: any) => {
        console.error('Error while trying to quote: ' + reason);
      });
  }, [countryCode, regionKey]);

  return (
    <VStack
      key={props.title}
      flex="1"
      mr={{ base: '0', md: props.removeRightMargin ? '0' : '6' }}
      mb={{ base: '10', md: '0' }}
    >
      <Box borderRadius="6px" boxShadow="lg" bg="white">
        <Image
          src={props.image.src}
          alt={props.image.alt}
          borderTopRadius="6px"
          width="100%"
        />
        <Box p="3">
          <Heading size="md" mb="2">
            {props.title}
          </Heading>
          {quote && (
            <Text fontSize="md" mb="2">
              $
              {parseFloat(quote.offsetPrice.value).toLocaleString(undefined, {
                minimumFractionDigits: quote.offsetPrice.zeroDecimalCurrency
                  ? 0
                  : 2,
                maximumFractionDigits: 2,
              })}{' '}
              {quote.offsetPrice.currency} / month
            </Text>
          )}

          <Text mb="2">{props.description}</Text>

          <Button disabled={!quoteURL} href={quoteURL} target="_blank" as="a">
            Select
          </Button>
        </Box>
      </Box>
      {quote && (
        <Text fontSize="sm" as="p">
          Offsets about{' '}
          {((parseInt(quote.carbonOffsetQuantity.value) * 12) / 1000).toFixed(2)} tonnes CO2
          yearly
        </Text>
      )}
    </VStack>
  );
};
